import PropTypes from 'prop-types';

const attributeType = PropTypes.exact({
  grade: PropTypes.string.isRequired,
  score: PropTypes.number.isRequired,
  weighted: PropTypes.bool.isRequired,
});

const attributesType = PropTypes.exact({
  coldRisk: attributeType.isRequired,
  composure: attributeType.isRequired,
  conscientiousness: attributeType.isRequired,
  hotRisk: attributeType.isRequired,
  inquisitive: attributeType.isRequired,
  interpersonalSkills: attributeType.isRequired,
  mentalHorsepower: attributeType.isRequired,
  physical: attributeType.isRequired,
  sociability: attributeType.isRequired,
  surveillance: attributeType.isRequired,
});

const archetypeType = PropTypes.exact({
  attributes: attributesType.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  percentage: PropTypes.number.isRequired,
});

const archetypeMatchType = PropTypes.exact({
  archetypes: PropTypes.arrayOf(archetypeType).isRequired,
  createdAt: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  profileId: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
  visitId: PropTypes.string,
});

const archetypeMatchesType = PropTypes.arrayOf(archetypeMatchType);

export default archetypeMatchesType;
